export const shopCoupon = [11, 12, 13, 21, 22, 23, 31, 32, 33, 41, 42, 43];

export const platformCoupon = [1, 2, 3];

export const discountCoupon = [1, 11, 21, 31, 41];

export const straightReducedCoupon = [2, 12, 22, 32, 42];

export const fullDiscountCoupon = [3, 13, 23, 33, 43];

export enum couponTypeConst {
    discount,
    straightReduced,
    fullDiscount
}

export enum couponScopeConst {
    platform,
    shop
}

export const canNotUseReason = {
    goodsNot: '所结算商品不符合使用条件',
    timeNot: ''
};
export const TYPE_LABELS: { [key: number]: string } = {
    1: '平台折扣券',
    2: '平台直减券',
    3: '平台满减券',
    11: '品类折扣券',
    12: '品类直减券',
    13: '品类满减券',
    21: '商家折扣券',
    22: '商家直减券',
    23: '商家满减券',
    31: '渠道折扣券',
    32: '渠道直减券',
    33: '渠道满减券',
    41: '单品折扣券',
    42: '单品直减券',
    43: '单品满减券'
};
